import { html, render } from "lit-html";
import Input from "../engine/input";
import { Commands } from "../engine/commands";
import Settings from "../engine/settings";


class ControlsSettings {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.dialog = document.querySelector(".log");
  }

  activate(context, ui) {
    this.gamepad = ui.gamepad;
    this.focusIndex = 0;
    this.nav = [];
    this.overlay.classList.add("is-visible");
    this.dialog.classList.add("is-visible");
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.dialog.classList.remove("is-visible");

    this.dialog.removeEventListener("focusin", this.focusHandler);
  }

  gamepadAvailableClass() {
    return this.gamepad.isConnected() ? "gamepad-connected" : "gamepad-disconnected";
  }

  handleClick(ev) {
    if (!this.dialog.contains(ev.target) || ev.target.matches(".button-ok")) {
      return Commands.HideDialog;
    }
  }

  handleInput(input, stage) {
    switch (input) {
      case Input.MoveDown:
      case Input.MoveRight:
      case Input.FocusRight:
      case Input.FocusNext:
        this.nextNavFocus();
        break;
      case Input.MoveUp:
      case Input.MoveLeft:
      case Input.FocusLeft:
        this.prevNavFocus();
        break;
      case Input.Ok:
        if (this.nav[this.focusIndex].matches(".button-ok")) {
          return Commands.HideDialog;
        } else if (this.nav[this.focusIndex].matches(".toggle-control")) {
          this.nav[this.focusIndex].click();
          break;
        }
      case Input.Cancel:
        return Commands.HideDialog;
    }
  }

  nextNavFocus() {
    this.focusIndex = (this.focusIndex + 1) % this.nav.length;
    this.nav[this.focusIndex].focus();
  }

  prevNavFocus() {
    this.focusIndex = ((this.focusIndex - 1) + this.nav.length) % this.nav.length;
    this.nav[this.focusIndex].focus();
  }

  togglePointerNav = (ev) => {
    Settings.usePointerNav = ev.target.checked;
  }

  handleRightClick(ev, stage) {
  }

  rescale() {
    return;
  }

  render(stage) {
    render(this.getControlsTemplate(), this.dialog);

    if (this.nav.length == 0) {
      this.nav = [
        //this.dialog.querySelector(".controls > table"),
        this.dialog.querySelector(".toggle-control"),
        this.dialog.querySelector(".button-ok"),
      ];
      this.nav[this.focusIndex].focus();

      this.focusHandler = this.dialog.addEventListener("focusin", ev => {
        if (this.nav.includes(ev.target)) {
          const index = this.nav.indexOf(ev.target);
          if (index != this.focusIndex) this.focusIndex = index;
        }
      });
    }
  }

  getControlsTemplate() {
    return html`
      <div class="controls">
          <table tabindex="1">
            <tr>
              <th>Gamepad</th>
              <th>Keyboard</th>
              <th>Action</th>
              <th>Description</th>
            </tr>
            <tr>  
              <td class=${this.gamepadAvailableClass()}>
                <table>
                  <tr>
                    <td></td>
                    <td><kbd>▲</kbd></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><kbd>◀</kbd></td>
                    <td></td>
                    <td><kbd>▶</kbd></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td><kbd>▼</kbd></td>
                    <td></td>
                  </tr>
                </table>
                <p><kbd>d-pad</kbd></p>
              </td>
              <td>
                <p class="control-set">
                  <kbd>←</kbd>
                  <kbd>↑</kbd>
                  <kbd>→</kbd>
                  <kbd>↓</kbd>
                </p>
                <p class="control-set">
                  <kbd>w</kbd>
                  <kbd>a</kbd>
                  <kbd>s</kbd>
                  <kbd>d</kbd>
                </p>
                <p class="control-set">
                  <kbd>h</kbd>
                  <kbd>j</kbd>
                  <kbd>k</kbd>
                  <kbd>l</kbd>
                </p>
              </td>
              <td>Move/Select</td>
              <td>
                <p>Move the player or cursor one step in the given direction or select the next menu option in a dialog.</p>
                <p>Bump into characters, critters and objects to interact with them.</p>
              </td>
            </tr>
            <tr>
              <td class=${this.gamepadAvailableClass()}>
                <p><kbd><span class="button-a">●</span>A</kbd></p>
                
              </td>
              <td><p><kbd>enter</kbd></p><p><kbd>space</kbd></p></td>
              <td>Ok/Confirm</td>
              <td><p>Enter the currently selected menu option or button.</p></td>
            </tr>
            <tr>
              <td class=${this.gamepadAvailableClass()}>
                <p><kbd><span class="button-b">●</span>B</kbd></p>
              </td>
              <td>
                <p><kbd>esc</kbd></p>
                <p><kbd>delete</kbd></p>
              </td>
              <td>Cancel/Close</td>
              <td><p>Cancels an active dialog or leaves the currently focused control.</p></td>
            </tr>
            <tr>
              <td class=${this.gamepadAvailableClass()}>
                <p><kbd><span class="button-y">●</span>Y</kbd></p>
              </td>
              <td>
                <p><kbd>q</kbd></p>
                <p class="control-set"><kbd>z</kbd> <kbd>/</kbd></p>
              </td>
              <td>Look Mode</td>
              <td><p>Switches from exploration mode to looking mode where you can examine nearby tiles with a cursor. Press <b>Ok</b> to look at the selected tile.</p></td>
            </tr>
            <tr>
              <td class=${this.gamepadAvailableClass()}>
                <p><kbd><span class="button-x">●</span>X</kbd></p>
              </td>
              <td>
                <p><kbd>x</kbd> <kbd>c</kbd></p>
              </td>
              <td>
                Open/Close
              </td>
              <td>
                <p>Opens and closes adjacent doors.</p>
              </td>
            </tr>
          </table>

          <div class="pointer-nav">
            <label class="toggle-control">
              <input tabindex="2" type="checkbox" id="pointer-nav" @click=${this.togglePointerNav} ?checked=${Settings.usePointerNav}>
              <span>Enable pointer navigation on tiles</span>
            </label>
            <p class="help">Left click to automatically pathfind to a tile. Right click to look.</p>
          </div>
      </div>
      <footer class="dialog-footer">
        <button tabindex="3" class="button-ok">Ok</button>
      </footer>
    `;
  }
}

export default ControlsSettings;